import { styled } from '@mui/material';

export const LogoWrapper = styled('img')(({ theme }) => ({
  height: 'auto',
  width: '100%',
  minWidth: '200px',
  maxWidth: '200px'
}));
